/* ═══════════════════════════════════════════════════
   MEMORIECAR — Motion Engine JS
   Architecture: Neo-Brutalism Light
   ═══════════════════════════════════════════════════ */

(function() {
  'use strict';

  // Wait for GSAP and DOM
  let gsapWaitAttempts = 0;

  function initMemoriecar() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      gsapWaitAttempts++;
      if (gsapWaitAttempts > 60) {
        // Fallback if GSAP fails to load after 3 seconds
        document.body.classList.remove('sys-loading');
        document.body.classList.add('sys-loaded');
        const preloader = document.querySelector('.sys-preloader');
        if (preloader) preloader.style.display = 'none';
        return;
      }
      setTimeout(initMemoriecar, 50);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    // ── PRELOADER ──
    const preloader = document.querySelector('.sys-preloader');
    if (preloader) {
      setTimeout(() => {
        document.body.classList.remove('sys-loading');
        document.body.classList.add('sys-loaded');
        gsap.to(preloader, {
          yPercent: -100,
          duration: 0.8,
          ease: "power3.inOut",
          onComplete: () => {
            preloader.style.display = 'none';
            initScrollAnimations();
          }
        });
      }, 1500); // Fake load time for arcade feel
    } else {
      document.body.classList.remove('sys-loading');
      document.body.classList.add('sys-loaded');
      initScrollAnimations();
    }
  }

  function initScrollAnimations() {
    // ── GSAP UTILITIES ──
    
    // Fade Up Elements
    const fadeUps = document.querySelectorAll('.sys-fade-up');
    fadeUps.forEach(el => {
      gsap.to(el, {
        scrollTrigger: {
          trigger: el,
          start: "top 85%",
        },
        y: 0,
        opacity: 1,
        duration: 0.6,
        ease: "power2.out",
        stagger: 0.1
      });
    });

    // Terminal Typewriter (FAQ)
    const typewriters = document.querySelectorAll('.sys-type-target');
    typewriters.forEach(el => {
      // Basic text reveal via GSAP (requires TextPlugin or simple character reveal)
      // For simplicity without TextPlugin loaded, we use a basic character opacity reveal
      const text = el.innerText;
      el.innerHTML = text.split('').map(char => `<span style="opacity:0">${char === ' ' ? '&nbsp;' : char}</span>`).join('');
      
      gsap.to(el.querySelectorAll('span'), {
        scrollTrigger: {
          trigger: el,
          start: "top 90%",
        },
        opacity: 1,
        duration: 0.05,
        stagger: 0.05,
        ease: "steps(1)"
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initMemoriecar);
})();
